import { Box, Button } from "@mui/material"
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { IFlowHubCarouselControls } from "../interfaces/flowHubCarousel.interface";
import { FLOW_HUB_BUTTON_TERTIARY_CONFIG } from "../../../../../config/flowhub.config";

const compactControlButtonSx = {
    ...FLOW_HUB_BUTTON_TERTIARY_CONFIG,
    minWidth: 26,
    width: 26,
    height: 26,
    p: 0,
    borderRadius: "6px",
    "& .MuiSvgIcon-root": {
        fontSize: 13,
    },
    "&:hover": FLOW_HUB_BUTTON_TERTIARY_CONFIG["&:hover"],
} as const;

export const FlowHubCarouselControls = ({
    totalSlides,
    currentIndex,
    handleNext,
    handlePrevious,
    goToSlide
}: IFlowHubCarouselControls) => {
    return (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", alignSelf: "center", gap: 0.6, py: 0.35, flexShrink: 0 }}>
            <Button sx={compactControlButtonSx} onClick={handlePrevious}>
                <ArrowBackIosIcon />
            </Button>

            <Box sx={{ display: "flex", gap: 0.55 }}>
                {Array.from({ length: totalSlides }).map((_, index) => (
                    <Box
                        key={index}
                        onClick={() => goToSlide(index)}
                        sx={{
                            width: 7,
                            height: 7,
                            borderRadius: "50%",
                            backgroundColor: index === currentIndex ? "#f08728" : "#ccc",
                            cursor: "pointer",
                            transition: "background-color 0.3s ease",
                            "&:hover": {
                                backgroundColor: index === currentIndex ? "#f08728" : "#999",
                            }
                        }}
                    />
                ))}
            </Box>

            <Button sx={compactControlButtonSx} onClick={handleNext}>
                <ArrowForwardIosIcon />
            </Button>
        </Box>
    )
}
